import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { analytics } from 'app/utils/segment';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { canConversationTransferToNumber } from 'components/conversation/utils/conversationTransfer';
import { transferToNumberActions } from 'components/shared/transferToNumberModal/actions/transferToNumberModal';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
const { transferToNumberModalOpen } = transferToNumberActions;
export const ConversationTransferToNumberButton = () => {
    const dispatch = useAppDispatch();
    const { metaConversation, telephony, transferToNumberRequests } = useAppSelector((state) => ({
        metaConversation: state.conversation.metaConversation,
        telephony: state.telephony,
        transferToNumberRequests: state.transferToNumber.transferRequests,
    }));
    const canTransfer = canConversationTransferToNumber(metaConversation, telephony.staticTelephoneNumbersArray);
    useCommandHandler({
        name: 'conversation:transferToNumber',
        actionFn: () => {
            if (canTransfer) {
                handleTransfer();
            }
        },
    });
    const handleTransfer = useCallback(() => {
        dispatch(transferToNumberModalOpen({ metaConversation }));
        analytics.conversationHeaderTransferToNumberButtonClicked();
    }, [dispatch, metaConversation]);
    const isTransferringToNumber = !!transferToNumberRequests.find((request) => {
        var _a, _b;
        return ((_b = (_a = request === null || request === void 0 ? void 0 : request.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation) === null || _b === void 0 ? void 0 : _b.id) ==
            metaConversation.conversation.id;
    });
    const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:transferToNumber" }, { children: "Transfer to number" })));
    return canTransfer ? (_jsx(Tooltip, Object.assign({ dark: true, content: tooltipContent }, { children: _jsx(IconButton, { variant: "tertiary", icon: "arrow-right", isLoading: isTransferringToNumber, onClick: () => handleTransfer() }) }))) : null;
};
